<template>
    <div>
        <v-dialog
            v-model="display"
            width="350"
            persistent>
            <v-card flat>
                <v-card-title>{{ $t('print') }}</v-card-title>
                <v-card-text v-if="loading.data">
                    {{ $t('print_msg_journal_list') }}
                    <div id="printJournalEntryList" style="display: none" >
                        <div>
                            <div class="row">
                                <div class="col-sm">  
                                    <div>
                                        <h4 class="text-left">Petra Ready Mixed Concrete</h4>
                                        <h4 class="text-left"><b>Accounting Department </b></h4>
                                        <h4 class="text-left">Journal Vouchers List</h4>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="row">
                                <div class="col-sm"> 
                                    <div v-if="journalEntryList" class="text-center">
                                        <h3>
                                            <b>{{ this.$t('sales_order_number') }} {{journalEntryList.code}}</b>
                                        </h3>
                                    </div>
                                </div>
                            </div> -->
                             <div class="row">
                                <div class="col-sm">
                                    <div class="text-left">
                                        <!-- <h2>{{ $t('account') }}: {{ form.account }}</h2> -->
                                        <b v-if="search.user">{{ $t('created_by') }}: {{ search.user }}</b>
                                        <br>
                                        <b v-if="search.from && search.to">  {{ $t('date') }}: {{ search.from }} {{ $t('to') }}  {{ search.to }}</b>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <br>
                            <div v-if="journalEntryList.length" class="row">
                                <div class="col-sm">
                                    <table style="width:100%;font-size:14px" class="table table-bordered table-sm" >
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>{{ $t('code') }}</th>
                                                <th>{{ $t('date') }}</th>
                                                <th>{{ $t('doc_date') }}</th>
                                                <th>{{ $t('reference') }}</th>
                                                <th>{{ $t('narration') }}</th>
                                                <th>{{ $t('total') }}</th>
                                                <th>{{ $t('status') }}</th>
                            
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(journalLine, index) in journalEntryList" :key="index">
                                                <td width="9px">{{ index + 1 }}</td>
                                                <td width="60px">{{ journalLine.code }}</td>
                                                <td width="100px">{{ journalLine.journal_date }}</td>
                                                <td width="100px">{{ journalLine.document_date }}</td>
                                                <td :style="isArabic(journalLine.reference) ? 'text-align: right;': ''" width="250px">{{ journalLine.reference }}</td>
                                                <td :style="isArabic(journalLine.narration) ? 'text-align: right;': ''" width="400px">{{ journalLine.narration }}</td>
                                                <td width="140px">{{ formatCurrency(journalLine.total) }}</td>
                                                <td  width="30px">{{ journalLine.status }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="print" text>
                        {{ $t('print') }}
                    </v-btn>
                    <v-btn @click="close" text>
                        {{ $t('close_btn') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { formatMoney } from 'accounting';
import isArabic from '@/utils/isArabic';
export default {
    name: "journalEntryListListPrintDialog",
    components: {},
    props: {
        journalEntryList: {
            type: Array,
            required: true
        },
        search: Object
    },
    data() {
        return {
            display: true,
            openParams: null,
            loading: {
                data: true
            }
        }
    },
    computed: {

    },
    methods: {
        isArabic,
        formatCurrency(amount) {
            return formatMoney(amount, 'SDG ' , 2);
        },
        close() {
           this.$emit('close');
        },
        print() {
            this.$htmlToPaper("printJournalEntryList");
            this.close();
        }
       
    },
}
</script>